export default __webpack_public_path__ + "static/media/l.8c866ad2.png";